<template>
  <AppCard
    @click="emits('tile-click')"
    class="use-case-card"
    :is-selected="isSelected"
    to="#"
    :is-actionable="true"
  >
    <template v-if="!isLoading">
      <div class="t-flex t-flex-align-items-center t-flex-justify-content-center t-mb-4">
        <div class="icon t-flex t-flex-align-items-center t-flex-justify-content-center">
          <slot name="icon">
            <scale-icon-action-upload accessibility-title="upload" size="24" />
          </slot>
        </div>
      </div>

      <h6 class="title t-mb-2">
        <slot name="title">
          {{ title }}
        </slot>
      </h6>
      <div class="desc">
        <slot name="description">
          {{ description }}
        </slot>
      </div>
    </template>
    <template v-else>
      <div class="t-flex t-flex-align-items-center t-flex-justify-content-center is-loading">
        <scale-loading-spinner />
      </div>
    </template>
  </AppCard>
</template>
<script setup lang="ts">
import AppCard from "@/components/global/TCard/TCard.vue"

defineProps({
  title: {
    type: String,
    default: ""
  },
  description: {
    type: String,
    default: ""
  },
  isSelected: {
    type: Boolean,
    default: false
  },
  isLoading: {
    type: Boolean,
    default: false
  }
})

const emits = defineEmits(["tile-click"])
</script>
<style scoped lang="scss">
@use "@/styles/mixins/typography.scss" as *;
.use-case-card {
  @include tg-caption;

  .is-loading {
    min-height: 220px;
  }
  .icon {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    overflow: hidden;
    color: #65b8e7; //TODO: replace with scale;
    background: #e9f5fc; //TODO: replace with scale;;
  }

  .title,
  .icon {
    text-align: center;
  }

  .title {
    @include tg-heading-6;
  }

  .desc {
    @include tg-caption;
    display: -webkit-box;
    line-clamp: 3;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    overflow: hidden;
    min-height: 60px;
  }

  .is-loading {
    min-height: 136px;
  }
}
</style>
